import { CarrierType } from '../../../types/carrier';
import Method, { MethodProps } from '../Method';

export const DropOffItem: MethodProps = {
  title: 'PUDO / Locker Drop Off',
  cost: '',
  description:
    'Book and drop your parcel off at a convenient location near you.',
  dropoff: true,
};

class DropOffMethod extends Method {
  private supportedDropOffCarriers: CarrierType[];

  constructor(
    position: number,
    supportedDropOffCarriers: CarrierType[],
    returnCharge?: string,
    currencyCode?: string
  ) {
    super(DropOffItem, position, null, returnCharge, currencyCode);
    this.supportedDropOffCarriers = supportedDropOffCarriers;
  }

  getSupportDropOffCarriers() {
    return this.supportedDropOffCarriers;
  }

  setDropoffCarrier(dropoffCarrier: CarrierType) {
    this.setType(dropoffCarrier);
  }

  getDropoffCarrier() {
    return this.getType()!;
  }
}

export default DropOffMethod;
